import moment from 'moment'
import { strings } from '../../assets/resources/translations'

/** Standard */
export const required = (value) => {
	const message = strings.errorRequired || "Error: Required field"
	return !value || value.trim(" ") === "" ? message : null
}

/** Formatting */
export const regex = (value, rule, customErrorMessage) => {
	const message = customErrorMessage || strings.errorBadFormat; // TODO: change
	return rule.test(value) === false && value !== "" ? message : undefined;
}


export const standard = (value) => {
	return regex(value, /^([A-z0-9åäöÅÄÖÆæØø-\s´`]*)$/i, strings.errorNonPermittedChar || "Error: Non-permitted character(s) used")
}

export const email = (value) => {
	const message = strings.errorEmailFormat || "Error: Not fulfilling email formatting"
	return regex(value, /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message)
}

export const telephone = (value) => {
	const message = strings.errorTelephone || "Error: Not fulfilling phonenumber format"
	return regex(value, /^([0-9]{9,10})$/i, message)
}

export const date = (value) => {
	const message = strings.errorDate || "Error: Not fulfilling date correct format"
	let date = moment(value, "YYYY-MM-DD", true)
	return (!date.isValid() ? message : null)
}

export const legal = (value) => {
	const message = strings.errorLegal || "Error: You have to agree to terms and condition to submit a request"
	return !value ? message : null
}